import type { OnChanges, SimpleChanges } from '@angular/core';
import { ChangeDetectionStrategy, Component, Input, output, input } from '@angular/core';

// eslint-disable-next-line boundaries/element-types
import { PdfViewerComponent } from '@core/pdf-viewer-smart-ui';
import {
  ButtonComponent,
  IconButtonComponent,
  TruncateComponent,
} from '@core/user-interface-legacy';

@Component({
  selector: 'rt-cover-letter-file',
  templateUrl: './cover-letter-file.component.html',
  styleUrls: ['./cover-letter-file.component.less'],
  imports: [PdfViewerComponent, ButtonComponent, IconButtonComponent, TruncateComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CoverLetterFileComponent implements OnChanges {
  public readonly closable = input(true);
  public readonly url = input('');
  @Input()
  public fileName = '';

  public closed = output<void>();
  public fileChange = output<void>();

  public encodedUrl = '';
  public ngOnChanges(changes: SimpleChanges) {
    const url = this.url();
    if (
      'url' in changes &&
      url.length &&
      this.isFileChanged(changes.url.currentValue, changes.url.previousValue)
    ) {
      this.encodedUrl = encodeURIComponent(url);
    }
  }

  private isFileChanged(current: string, previous: string): boolean {
    /*
      URL parameters like algorithm, credentials, date, expiration will change. In order to avoid updating
      the encoded url and propagating changes to pdf-viewer we need to cut the parameters off for comparison.
    */
    if (!current?.length || !previous?.length) {
      return true;
    }

    const currentUrl = new URL(current);
    const previousUrl = new URL(previous);
    const currentUrlWithoutParams = `${currentUrl.host}${currentUrl.pathname}`;
    const previousUrlWithoutParams = `${previousUrl.host}${previousUrl.pathname}`;
    return currentUrlWithoutParams !== previousUrlWithoutParams;
  }
}
